export default function (state, {data, form}) {
    state.url = data.ExportReport.Url+form;
}